import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SvgIconComponent} from '../svg-icon/svg-icon.component';
import {ButtonComponent} from '../button/button.component';
import {ToasterConfig} from 'shared';

@Component({
  selector: 'tngh-toaster',
  standalone: true,
  imports: [CommonModule, SvgIconComponent, ButtonComponent],
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.scss']
})
export class ToasterComponent implements OnInit {
  @Input({ required: true }) config!: ToasterConfig;
  @Output() closeToaster = new EventEmitter<ToasterConfig>();

  ngOnInit(): void {
    setTimeout(() => {
      this.closeToasterEventHandler();
    }, this.config.duration ?? 10000);
  }

  closeToasterEventHandler() {
    this.closeToaster.emit(this.config);
  }
}
